import * as React from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import type { FieldItem } from './EditorTypes';

interface ListEditDialogProps {
  visible: boolean;
  fields: FieldItem[];
  setFields: (items: FieldItem[]) => void;
  onHide: () => void;
  onApply: () => void;
}

export const ListEditDialog: React.FC<ListEditDialogProps> = (props) => {
  const { visible, fields, setFields, onHide, onApply } = props;

  const footer = (
    <div className="d-flex justify-content-end" style={{ gap: '0.5rem' }}>
      <Button label="Отмена" icon="pi pi-times" severity="secondary" onClick={onHide} />
      <Button label="Применить" icon="pi pi-check" onClick={onApply} />
    </div>
  );

  return (
    <Dialog
      header="Редактирование списком"
      visible={visible}
      style={{ width: '720px', maxWidth: '95vw' }}
      modal
      onHide={onHide}
      footer={footer}
    >
      <div style={{ maxHeight: '60vh', overflowY: 'auto', paddingRight: '8px' }}>
        {fields.length === 0 ? (
          <div>
            Нет доступных элементов для редактирования
          </div>
        ) : (
          <div className="p-fluid grid" style={{ gap: '8px 12px' }}>
            {fields.map((f, idx) => (
              <div key={f.key} className="col-12">
                <div className="p-field">
                  <label htmlFor={`fld-${idx}`} style={{ display: 'block', fontWeight: 600 }}>
                    {f.label}{f.required ? ' *' : ''}
                  </label>
                  {f.enumList ? (
                    <Dropdown
                      id={`fld-${idx}`}
                      options={f.enumList.map(v => ({ label: v, value: v }))}
                      value={f.value}
                      onChange={(e) => {
                        const next = [...fields];
                        next[idx] = { ...f, value: String(e.value ?? '') };
                        setFields(next);
                      }}
                      placeholder="Выберите значение"
                      className="w-100"
                    />
                  ) : (
                    <InputText
                      id={`fld-${idx}`}
                      value={f.value}
                      onChange={(e) => {
                        let v = e.target.value;
                        if (f.maxLen > 0 && v.length > f.maxLen) v = v.slice(0, f.maxLen);
                        const next = [...fields];
                        next[idx] = { ...f, value: v };
                        setFields(next);
                      }}
                      className="w-100"
                    />
                  )}
                  <small style={{ color: '#666' }}>
                    {f.type === 'number' && (f.min || f.max) ? `Диапазон: ${f.min ?? '—'}..${f.max ?? '—'} ` : ''}
                    {f.type === 'number' && f.decimals && f.decimals > 0 ? `(десятичных: ${f.decimals}) ` : ''}
                    {f.maxLen > 0 ? `Макс. длина: ${f.maxLen}` : ''}
                  </small>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </Dialog>
  );
};

